export const IconMaker = (props) => (
  <img {...props} src={`/svg/${props.name?.toLowerCase()}.svg`} />
);
